const _ = require('underscore');

/**
 * Посчитать массив страниц для пагинации
 *
 * @param {number} current - текущая страница
 * @param {number} total - страниц всего
 * @param {number} delta - количество добавляемых страниц к текущей
 * @returns {number[] | null[]} - массив страниц
 */
function pagination(current, total, delta = 1) {
	const left = Math.max(1, current - delta);
	const right = Math.min(current + delta, total);

	let arr = _.range(left, right + 1);

	if (left === 2) {
		arr = [1, ...arr];
	} else if (left > 2) {
		arr = [1, null, ...arr];
	}

	if (right + 1 === total) {
		arr.push(total);
	} else if (right < total) {
		arr.push(null, total);
	}

	return arr;
}

export default pagination;
